// Tenant realm resolution, split out of `routes/AuthContext` so modules that only need the realm
// don't have to import that file — importing it initialises Keycloak (top-level `await
// keycloak.init`), which a data module or a unit test has no business triggering.
//
// `AuthContext` re-exports this, so the ~30 existing `getRealmName` imports are unaffected.

// Captured at module load, matching the original behaviour: the realm is fixed for the life of the
// page, and reading it lazily would let an in-app navigation change the answer on localhost.
const hostName = window.location.hostname;
const pathName = window.location.pathname;

/**
 * The tenant realm: the leading label of the hostname (`acme-insights.restoreskills.com` → `acme`).
 * On localhost there is no tenant subdomain, so it falls back to `localStorage.realm`, then to the
 * first path segment.
 */
export const getRealmName = () => {
  if (hostName === 'localhost') {
    if (localStorage.getItem('realm')) {
      return localStorage.getItem('realm');
    }
    return pathName.split('/')[1];
  }
  return hostName.split('-')[0];
};
